export default "__VITE_ASSET__DWHOYmHz__"